import { ref } from 'vue';
// Module-level refs so the SpendingAnalysisPage's filter selections survive
// component unmount (e.g. navigating into TransactionDetail and back).
export const selectedFilter = ref('all');
export const selectedPeriod = ref('month');
export const selectedAccount = ref('all');
export const selectedSubCategory = ref('');
export const selectedSubCategoryColour = ref('');
export const selectedMerchant = ref('');
export const dateSelection = ref(null);
// Default: on. Persisted in localStorage; only false when explicitly stored as 'false'.
export const snapToSpendingCycle = ref(localStorage.getItem('snapToSpendingCycle') !== 'false');
// Set by TransactionDetail before navigating in; consumed by SpendingAnalysis's
// logical-back so back returns to the transaction instead of unwinding filters.
export const cameFromTransactionDetail = ref(false);
